// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.
import { version } from '../../package.json'

export const environment = {
  version,
  production: false,
  firebase: {
    apiKey: 'AIzaSyC3HyWTPxfCJjlqnATysAa-mH4qi5TOILc',
    authDomain: 'sigresidencias.firebaseapp.com',
    projectId: 'sigresidencias',
    storageBucket: 'sigresidencias.appspot.com',
    messagingSenderId: '955213390584',
    appId: '1:955213390584:web:45cba4286c61eb3641510d',
    measurementId: 'G-2LL1ENMP04',
  },
}

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
